import queryString from "query-string";

export function generateQueryString(params:object, hidePage:boolean = false) {
  const keys = hidePage
    ? Object.keys(params).filter((key) => params[key] !== "" && key !== "page")
    : Object.keys(params).filter((key) => params[key] !== "");

  const paramsObject = {};
  keys.forEach((key) => {
    paramsObject[key] = params[key];
  });

  return queryString.stringify(paramsObject);
}

export function parseQueryString(params:string) {
  return queryString.parse(params, { parseNumbers: true });
}
